import React from 'react';
import { CardFooter } from 'reactstrap';
import CardInlineActions from './CardInlineActions';

const CommonFooterActions = (props) => {
    const { workflow, data, inlineActions,isImageCard, cardConfig: { config: { isFullWidth } }, editActionId, menuTypeInlineAction } = props;
const filteredActions = (inlineActions || []).filter(function(action) {

    if (!action || !action.actionProperties) return false;

    const ap = action.actionProperties;

    if (ap.systemGenerated === true) return false;

    if (ap.inlineActionPlacement !== 'INLINE') return false;

    if (ap.entireCardClickable === true) return false;

    if (
        props.containerIndex !== undefined &&
        ap.targetContainer !== null &&
        ap.targetContainer !== undefined &&
        Number(ap.targetContainer) !== Number(props.containerIndex)
    ) return false;

    return true;

});

if(isImageCard){
            return (
                filteredActions.length ? 
        <CardFooter className={'imageCard-footer'}  onClick={(e) => e.stopPropagation()}>
                <div className='imageCard-inline-actions'>
                    <CardInlineActions isFullWidth={isFullWidth} editActionId={editActionId}
                    workflow={workflow} data={data} wfData={data} actions={filteredActions} menuTypeInlineAction={menuTypeInlineAction}/>
                </div> 
        </CardFooter>: ''
)
   }
    return (
                filteredActions.length ? 
        <CardFooter  onClick={(e) => e.stopPropagation()}>
                 <div className='card-inline-actions'>
                    <CardInlineActions isFullWidth={isFullWidth} editActionId={editActionId}
					workflow={workflow} data={data} wfData={data} actions={filteredActions} menuTypeInlineAction={menuTypeInlineAction}/>
                </div> 
        </CardFooter>: ''
    )
}

export default CommonFooterActions;